import React from "react";
import {
  IonGrid,
  IonRow,
  IonCol,
  IonCard,
  IonCardContent,
  IonImg,
  IonText
} from "@ionic/react";
import './PostsContainer.css';
import ReactAudioPlayer from 'react-audio-player';

export const Audio = (props: {
  listOfPosts: any;
  totPages: number;
  handleClickNextPage: any;
}) => {
/*function stopAll(){
  console.log("stop the sounds");
}*/

  return (
     
    <IonGrid>
      <IonRow>
      {props.listOfPosts.map(
        (
          post: {
            audio_file_link: any,
            thumb_link: any,
            file_title: any,
            file_description: any,
          },
          index: string | number | null | undefined
        ) => (
          <IonCol key={index} className="col" size='12' size-sm='4'>
            <IonCard style={{padding:'10px'}}>
            <IonCardContent class="listitem" >
            <IonRow className="row">
                          <IonImg src={post.thumb_link}></IonImg>
                          <IonText class="movietitle" style={{padding:'10px 10px 0px 10px'}}>{post.file_title}</IonText>
                          <IonText style={{padding:'0px 10px 10px 10px'}}>{post.file_description}</IonText>
                          <ReactAudioPlayer
                            src={post['audio_file_link']}
                            //ref={(element) => { var rap = element; }}
                            autoPlay={false}
                         
                            controls
                          />
                 
              </IonRow>
              </IonCardContent>
              </IonCard>
          </IonCol>
        )
      )}
      </IonRow>
    </IonGrid>
  );
};
